import React from 'react';
import Chart from 'react-apexcharts';

const PieChart = ({ 
  data = [], 
  labels = [], 
  title = "Pie Chart",
  height = 350,
  colors = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6'],
  showLegend = true,
  showDataLabels = true
}) => {
  const options = {
    chart: {
      type: 'pie',
      height: height
    },
    labels: labels,
    colors: colors,
    title: {
      text: title,
      align: 'left',
      style: {
        fontSize: '16px',
        fontWeight: 600,
        color: '#374151'
      }
    },
    legend: {
      show: showLegend,
      position: 'bottom',
      horizontalAlign: 'center',
      fontSize: '12px',
      labels: {
        colors: '#6B7280'
      }
    },
    dataLabels: {
      enabled: showDataLabels,
      style: {
        fontSize: '12px',
        fontWeight: 600
      },
      formatter: function (val) {
        return val.toFixed(1) + "%"
      }
    },
    plotOptions: {
      pie: {
        donut: {
          size: '0%'
        }
      }
    },
    tooltip: {
      theme: 'light',
      y: {
        formatter: function (val) {
          return val + " calls"
        }
      }
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        legend: {
          position: 'bottom'
        }
      }
    }]
  };

  const series = data;

  return (
    <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm">
      <Chart 
        options={options} 
        series={series} 
        type="pie" 
        height={height} 
      />
    </div>
  );
};

export default PieChart;
